import {
  SET_READER_CONNECTION,
  SET_SDK_CONNECTION,
  SET_SDK_REGISTERATION,
  SET_KEY_MODEL,
  SET_KEY_MULTITASK,
  SET_PAD_CONNECTION,
  SET_FACTORY_AVAILABLE,
} from '../constants/SDKConstants';

export function setReaderConnection(status) {
  return {
    type: SET_READER_CONNECTION,
    payload: status,
  };
}

export function setSDKConnection(status) {
  return {
    type: SET_SDK_CONNECTION,
    payload: status,
  };
}

export function setSDKRegistration(status) {
  return {
    type: SET_SDK_REGISTERATION,
    payload: status,
  };
}

export function setKeyModel(model) {
  return {
    type: SET_KEY_MODEL,
    payload: model,
  };
}

export function setKeyMultiTask(multi) {
  return {
    type: SET_KEY_MULTITASK,
    payload: multi,
  };
}

export function setPadConnection(status) {
  return {
    type: SET_PAD_CONNECTION,
    payload: status,
  };
}

export function setFactoryAvailable(available) {
  return {
    type: SET_FACTORY_AVAILABLE,
    payload: available,
  };
}
